/* LIBRAIRIRES */
import React, { useState, useEffect, useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { auth, firestore } from '../../firebase'; //importer votre instance firebase

/* LOADER */
import { Triangle } from 'react-loader-spinner';

/* FIREBASE */
import { collection, doc, getDoc } from 'firebase/firestore';

/* CONTEXT */
import { UserContext } from '../../useContext';

/* CSS */
import './ProtectedRoute.css';

const ProtectedRoute = () => {
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState("");
    const { setUserRole, setUserInfos } = useContext(UserContext); // récupération de la fonction setUserRole depuis le context
  
    useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged((user) => {
        if (user) {
          // utilisateur authentifié, récupérer le rôle depuis Firestore
            const userRef = doc(collection(firestore, "users"), user.uid);
            getDoc(userRef)
            .then((doc) => { //Ici on recupere le role du user
                if (!doc.exists()) {
                    /* setUserRole(doc.data().role); */
                    /* ICI confirmer la suppression definitive */
                    setUserInfos({}); 
                    setUserRole('');
                    auth.currentUser.delete();
                    setAuthenticated(false);
                    setLoading(false);
                } else {
                    setUserInfos(doc.data()); 
                    setUserRole(doc.data().role);
                    setAuthenticated(true);
                    setLoading(false);    
                }
            })
            .catch((error) => {
                console.log("Error getting user role:", error);
                setAuthenticated(false);
                setLoading(false);
            });
        } else {
          // utilisateur non authentifié
          setAuthenticated(false);
          setLoading(false);
        }
      });
  
      // nettoyer l'abonnement lorsqu'on quitte le component
      return unsubscribe;
    }, []);
  
    if (loading) {
      /* return <div>Chargement en cours...</div>; */
        return (
            <div className='modal-loader'>
                <Triangle
                    height="150"
                    width="150"
                    color="#FFD700"
                    ariaLabel="triangle-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
            </div>
        )
    }
  
    return (
      <div style={{height: "100%"}}>
        {authenticated ? <Outlet role={role} /> : <Navigate to="/Login" />}
      </div>
    );
  };
  
  export default ProtectedRoute;